import { twMerge } from "tailwind-merge";
import { HiOutlineOfficeBuilding } from "react-icons/hi";

type MainTableProps = {
  getTableProps: any;
  getTableBodyProps: any;
  headerGroups: any[];
  rows: any[];
  prepareRow: (row: any) => void;
  currentRows: any[];
  onRowClick?: (row: any) => void;
  selectedRow?: any
};

export default function MainTable({
  getTableProps,
  getTableBodyProps,
  headerGroups,
  prepareRow,
  currentRows,
  onRowClick,
  selectedRow
}: MainTableProps) {
  const numColumns = headerGroups[0]?.headers.length || 1;
  return (
  <table {...getTableProps()} className="min-w-full text-left text-sm">
      <thead className="border-b font-medium dark:border-neutral-500 uppercase">
        {headerGroups.map(headerGroup => {
          const { key, ...restHeaderGroupProps } = headerGroup.getHeaderGroupProps();
          return (
            <tr key={key} {...restHeaderGroupProps}>
              {headerGroup.headers.map(column => {
                const { key, ...restColumnProps } = column.getHeaderProps();
                return (
                  <th className="px-3 py-2 text-left" key={key} {...restColumnProps}>
                    {column.render("Header")}
                  </th>
                );
              })}
            </tr>
          );
        })}
      </thead>
      <tbody {...getTableBodyProps()}>
        {currentRows.length === 0 ?
          <tr>
            <td colSpan={numColumns} className="text-center py-8 text-gray-500">
              No Data Available
            </td>
          </tr> : currentRows.map((row, i) => {
            prepareRow(row);
            const { key, ...restRowProps } = row.getRowProps();
            const isSelected = selectedRow && row.id === selectedRow.id;
            return (
              <tr
                key={key}
                className={twMerge(
                  "hover:bg-orange-1000 hover:text-white text-base cursor-pointer",
                  i % 2 === 0
                  ? "border-b bg-white dark:border-neutral-500 dark:bg-neutral-600"
                  : "border-b bg-neutral-100 dark:border-neutral-500 dark:bg-neutral-700",
                  isSelected && "bg-orange-200 font-medium",
                )}
                onClick={() => onRowClick?.(row)}
                {...restRowProps}
              >
                {row.cells.map(cell => {
                  const { key, ...restCellProps } = cell.getCellProps();
                  return (
                    <td className="px-3 py-2 text-left" key={key} {...restCellProps}>
                      <div className="flex items-center">
                        {key.includes("project") && !!row.values.project && (
                          <HiOutlineOfficeBuilding className="mr-2" style={{ color: "#fdb419" }} />
                        )}
                        {cell.render("Cell")}
                      </div>
                    </td>
                  );
                })}
              </tr>
            );
          })}
      </tbody>
    </table>
  );
}
